export const ScanRunStatusConstants = {
  Running: 0,
  Succeeded: 1,
  Failed: 2,
  Cancelled: 3,
  Queued: 4,
};

export const ScanRunStatusDisplayNames: Record<number, string> = {
  [ScanRunStatusConstants.Running]: $localize`Läuft`,
  [ScanRunStatusConstants.Succeeded]: $localize`Erfolgreich`,
  [ScanRunStatusConstants.Failed]: $localize`Fehlgeschlagen`,
  [ScanRunStatusConstants.Cancelled]: $localize`Abgebrochen`,
  [ScanRunStatusConstants.Queued]: $localize`Wartend`,
};

export interface ScanRun {
  id?: string;
  scanProviderBindingId: string;
  startedAt: Date;
  finishedAt?: Date;
  status: number;
  itemsDiscovered: number;
  itemsCreated: number;
  itemsUpdated: number;
  itemsSkipped: number;
  itemsErrored: number;

  // Catalog publish activity (backend #503 A5): the counters above describe the
  // scan ledger; these two count what actually reached the catalog — listings
  // newly created resp. updated by this run.
  itemsListed: number;
  itemsListingUpdated: number;
  errorMessage?: string;
}
